import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Switch,
} from '@mui/material';

interface AccessibilityTabProps {
  colors: any;
  glassStyle: any;
}

const AccessibilityTab: React.FC<AccessibilityTabProps> = ({ colors, glassStyle }) => {
  return (
    <Box>
      <Typography variant="h5" fontWeight={800} color={colors.textPrimary} sx={{ mb: 1 }}>
        Accessibility
      </Typography>
      <Paper elevation={0} sx={{ bgcolor: colors.cardBg, borderRadius: '24px', p: 4, ...glassStyle }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Box>
            <Typography fontWeight={700} color={colors.textPrimary}>Reduced Motion</Typography>
            <Typography variant="body2" color={colors.textSecondary}>Reduce the amount of animation and movement.</Typography>
          </Box>
          <Switch color="success" />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box>
            <Typography fontWeight={700} color={colors.textPrimary}>High Contrast</Typography>
            <Typography variant="body2" color={colors.textSecondary}>Increase contrast for better visibility.</Typography>
          </Box>
          <Switch color="success" />
        </Box>
      </Paper>
    </Box>
  );
};

export default AccessibilityTab;